import React from "react";
import ConractUsBanner from "./components/conractUsBanner";
import ContactInfoBanner from "./components/contactInfoBanner";
import OurBranches from "./components/ourBranches";
import MetaTagsSEO from "../../utils/metaTagsFunction";
import DB from "../../utils/db.json";

function ContactUsPage() {
  return (
    <>
      <MetaTagsSEO metaTags={DB.contactUsMetaTags} title="Contact Us - JBGlass" />

      <ConractUsBanner />

      <ContactInfoBanner />

      <OurBranches />
    </>
  );
}

export default ContactUsPage;
